import React from 'react';

type InputProps = {
    label: string,
    name: string,
    type: string,
    id: string,
    placeholder: string,
    autoComplete : string
    required: boolean,
    onChange: any,
    refObj: any
}


export const Input = ({ label, name, type, id, placeholder, autoComplete, required, onChange, refObj}: InputProps) => <aside>
    <div>
        <label htmlFor={id} className="sr-only">{label}</label>
        <input ref={refObj} id={id} name={name} type={type} autoComplete={autoComplete} required={required}
               className="relative block w-full appearance-none rounded-none rounded-t-md border border-gray-300 px-3 py-2 text-gray-900 placeholder-gray-500 focus:z-10 focus:border-indigo-500 focus:outline-none focus:ring-indigo-500 sm:text-sm"
               placeholder={placeholder} onChange={(e) => onChange(e.target.value)}/>
    </div>
</aside>